module.exports = __webpack_public_path__ + "static/media/4.9b7311d9.jpg";